'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('message', {
      url: '/account/message',
      template: '<message></message>'
    });
}



// WEBPACK FOOTER //
// ./client/app/account/message/message.routes.js